import styled from "@emotion/styled";
import { Flex } from "@radix-ui/themes";

import { Text } from "@src/ui-kit";
import { theme } from "@themes/themes";

export const MarketDataContainer = styled(Flex)`
  align-items: center;
  background-color: ${theme.color("gray-2")};
  border: 1px solid ${theme.color("gray-6")};
  border-radius: 8px;
  height: 58px;
  padding: 8px;
`;

export const MarketDataContainerMobile = styled(Flex)`
  flex-direction: column;
  align-items: center;
  background-color: ${theme.color("gray-2")};
  border: 1px solid ${theme.color("gray-6")};
  border-radius: 8px;
  padding: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
`;

export const DataContainer = styled(Flex)`
  flex-direction: column;
  gap: 2px;
  padding: 0 24px;
`;

export const DataContainerMobile = styled(Flex)`
  flex-direction: column;
  gap: 2px;
  font-size: 11px;
`;

export const MobileHeaderSection = styled.div`
  width: 100%;
`;

export const TopRow = styled(Flex)`
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 10px;
  padding: 2px 0;
`;

export const PriceSection = styled.div`
  width: 100%;
  padding: 4px 0;
`;

export const PriceRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  width: 100%;
`;

export const StatsSection = styled.div`
  width: 100%;
  padding: 4px 0;
`;

export const MobileGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px 8px;
  width: 100%;
  font-size: 11px;
`;

export const FundingSection = styled.div`
  width: 100%;
  padding: 4px 0;
`;

export const FundingRow = styled(Flex)`
  width: 100%;
`;

export const DataLabel = styled.span`
  ${theme.font.support10};
  color: ${theme.color("gray-11")};
`;

export const TooltipText = styled(Text)`
  ${theme.font.body12};
`;

export const MonoText = styled(Text)`
  font-family: "IBM Plex Mono", monospace;
`;

export const MarkPriceText = styled(Text)`
  font-family: "IBM Plex Mono", monospace;
  font-size: 18px;
`;
